// extracted by mini-css-extract-plugin
export default {"photo":"photo--Lq_wY","btn":"btn--nRNSP","icon":"icon--V7kWU","title":"title--vbyiI","invalidStateBtn":"invalidStateBtn--oRIVI","email":"email--B3y5h","heading":"heading--mCFSL"};